import { useEffect, useMemo, useState } from "react";
import { Carousel } from "./Carousel";
import "./BooksPublishedSection.css";

import { fetchCarouselBooks, proxiedImageUrl } from "../../Api/Backend/CarouselBook";
import {
  CAROUSEL_CATEGORIES,
  isValidCarouselCategory,
} from "../../data/carouselBookCategories";

const byDisplayOrder = (a, b) => {
  const av = a.displayOrder == null ? Number.MAX_SAFE_INTEGER : a.displayOrder;
  const bv = b.displayOrder == null ? Number.MAX_SAFE_INTEGER : b.displayOrder;
  return av - bv;
};

const BooksPublishedSection = () => {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState("IT");

  useEffect(() => {
    fetchCarouselBooks({
      onSuccess: (data) => {
        setBooks(Array.isArray(data) ? data : []);
        setLoading(false);
      },
      onError: (error) => {
        console.error("Error fetching carousel books:", error);
        setBooks([]);
        setLoading(false);
      },
    });
  }, []);

  const { row1, row2 } = useMemo(() => {
    const inCategory = books.filter(
      (book) =>
        isValidCarouselCategory(book.category) &&
        book.category === activeCategory
    );
    const prep = (rows) =>
      rows
        .slice()
        .sort(byDisplayOrder)
        .map((b) => ({ ...b, imageUrl: proxiedImageUrl(b.imageUrl) }));
    return {
      row1: prep(inCategory.filter((b) => b.carouselRow !== 2)),
      row2: prep(inCategory.filter((b) => b.carouselRow === 2)),
    };
  }, [books, activeCategory]);

  const hasBooks = row1.length > 0 || row2.length > 0;

  return (
    <section className="books-published-section">
      <h1>IT부터 에세이까지, 에이콘이 만든 이야기들</h1>

      <div className="book-filter-tabs">
        {CAROUSEL_CATEGORIES.map((tab) => (
          <button
            key={tab.value}
            type="button"
            className={`book-filter-tab${activeCategory === tab.value ? " active" : ""}`}
            onClick={() => setActiveCategory(tab.value)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="carousel-rows">
        {!loading && !hasBooks ? (
          <p className="books-empty">등록된 도서가 없습니다.</p>
        ) : (
          <>
            <Carousel
              items={row1}
              sendInteraction={() => console.log("Interaction tracked")}
            />
            <Carousel
              items={row2}
              sendInteraction={() => console.log("Interaction tracked")}
            />
          </>
        )}
      </div>
    </section>
  );
};

export default BooksPublishedSection;
